import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseSupportChat = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_38048_397)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M15.35 18.9892C15.6422 18.9603 15.9327 18.9292 16.2214 18.8969C17.9401 18.7054 19.3232 17.3224 19.5071 15.6028C19.6429 14.3335 19.7576 13.0302 19.7576 11.7016C19.7576 10.373 19.6429 9.06976 19.5071 7.80038C19.3232 6.08086 17.9401 4.69786 16.2214 4.50629C14.9448 4.364 13.6341 4.24178 12.2977 4.24178C10.9614 4.24178 9.65065 4.364 8.37406 4.50629C6.65537 4.69786 5.27238 6.08086 5.08841 7.80038C5.05856 8.07935 5.02974 8.35995 5.00293 8.6421",
				stroke: "black",
				strokeWidth: 1.29,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.36777 17.969C4.46027 18.8336 5.15563 19.5289 6.01978 19.6252C6.66163 19.6967 7.32066 19.7582 7.99258 19.7582C8.66449 19.7582 9.32352 19.6967 9.96539 19.6252C10.8295 19.5289 11.5249 18.8336 11.6174 17.969C11.6857 17.3307 11.7433 16.6755 11.7433 16.0075C11.7433 15.3395 11.6857 14.6842 11.6174 14.046C11.5249 13.1814 10.8295 12.486 9.96539 12.3897C9.32352 12.3182 8.66449 12.2567 7.99258 12.2567C7.32066 12.2567 6.66163 12.3182 6.01978 12.3897C5.15563 12.486 4.46027 13.1814 4.36777 14.046C4.29948 14.6842 4.24182 15.3395 4.24182 16.0075C4.24182 16.6755 4.29948 17.3307 4.36777 17.969Z",
				stroke: "black",
				strokeWidth: 1.29,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.4759 7.33541L13.1936 10.6177",
				stroke: "black",
				strokeWidth: 1.29,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.0435 10.747C15.1439 11.0469 13.9445 11.0469 13.045 10.7471C12.7451 9.84748 12.7451 8.64806 13.045 7.7485",
				stroke: "black",
				strokeWidth: 1.29,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_38048_397",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 18,
			height: 18,
			fill: "white",
			transform: "translate(3 3)"
		})
	}) })]
});
export default SvgCloseSupportChat;
